var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconScrollButton = function SvgIconScrollButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#12951a",
    fillOpacity: 0.6,
    rx: 50
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "m14 28 11-10 10 10"
  })));
};
export default SvgIconScrollButton;